<div
  class="tooltip-ctrl"
  [ngClass]="{ visible: visible || editMode, 'tooltip-absolute': absolute }"
  [style.top]="top"
  [style.left]="left"
  *ngIf="!!value.Text || canEdit"
>
  <button type="button" class="btn btn-link btn-flat" (click)="show()" tabindex="-1">
    <i class="fa fa-info-circle" aria-hidden="true"></i>
  </button>
</div>
<div class="tooltip-panel" *ngIf="visible">
  <div class="tooltip-header">
    <button type="button" class="close" aria-label="Close" (click)="hide()">
      <span aria-hidden="true">&times;</span>
    </button>
    <span>{{ value?.Title }}</span>
  </div>
  <div class="tooltip-body" [innerHTML]="text"></div>
  <div class="tooltip-footer" *ngIf="canEdit">
    <button type="button" class="btn btn-link pull-right" (click)="switchMode()">Edit</button>
  </div>
</div>
<div class="tooltip-panel" *ngIf="editMode">
  <div class="tooltip-header">
    <button type="button" class="close" aria-label="Close" (click)="hide()">
      <span aria-hidden="true">&times;</span>
    </button>
    <span>Tooltip Editor</span>
  </div>
  <div class="tooltip-body">
    <div class="form-group">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="value.Title"
        placeholder="Tooltip Title"
      />
    </div>
    <div class="form-group" style="background-color: white">
      <quill-editor
        [(ngModel)]="value.Text"
        [modules]="editorModules"
        placeholder="Type here tooltip text..."
      ></quill-editor>
    </div>
  </div>
  <div class="tooltip-footer">
    <button type="button" class="btn btn-link pull-right" (click)="save()" [disabled]="saving">
      Save
    </button>
  </div>
</div>
